if(!window.alpineData) {
  window.alpineData = {};
}

document.addEventListener("DOMContentLoaded", function () {
  const cartDropdown = document.getElementById("cart-dropdown");
  if (cartDropdown) {
    cartDropdown.addEventListener("click", function (e) {
      // stop dropdown from closing on dropdown menu click
      e.stopPropagation();
    });
  }

  const targetNodeCheckoutPage = document.getElementById("checkout-steps");
  if (targetNodeCheckoutPage) {
    const configCheckoutPage = { childList: true, subtree: true };
    const callback = function (mutationsList, observer) {
      // Use traditional 'for loops' for IE 11
      for (const mutation of mutationsList) {
        if (mutation.type === "childList") {
          // Fetch all the forms we want to apply custom Bootstrap validation styles to
          var forms = document.querySelectorAll(".needs-validation");

          // Loop over them and prevent submission
          Array.prototype.slice.call(forms).forEach(function (form) {
            form.removeEventListener("submit", { capture: false });
            form.addEventListener(
              "submit",
              function (event) {
                // console.log('Validity Check');
                if (!form.checkValidity()) {
                  event.preventDefault();
                  event.stopPropagation();
                }

                form.classList.add("was-validated");
              },
              false
            );
          });
        }
      }
    };

    const observerCheckoutPage = new MutationObserver(callback);
    observerCheckoutPage.observe(targetNodeCheckoutPage, configCheckoutPage);
  }
});

(function () {
  "use strict";

  // Fetch all the forms we want to apply custom Bootstrap validation styles to
  var forms = document.querySelectorAll(".needs-validation");

  // Loop over them and prevent submission
  Array.prototype.slice.call(forms).forEach(function (form) {
    form.addEventListener(
      "submit",
      function (event) {
        // console.log('Validity Check');
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
        }

        form.classList.add("was-validated");
      },
      false
    );
  });
})();
